import { render } from "./VerificationCode.vue?vue&type=template&id=20f2c30a"
import script from "./VerificationCode.vue?vue&type=script&lang=js"
export * from "./VerificationCode.vue?vue&type=script&lang=js"

import "./VerificationCode.vue?vue&type=style&index=0&id=20f2c30a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__